





















































/*eslint-disable */
import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import store                                   from '@/store';

const LayerCheckbox: object = defineComponent({
  props: {
    checked: {
      type: Boolean,
      default: true,
      name: 'checked',
    },
    small: {
      type: Boolean,
      default: false,
      name: 'small',
    },
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: 'icomoon-layers-events',
      name: 'icon',
    },
    label: {
      type: String,
      default: '<BRAK DANYCH>',
      name: 'label',
    },
  },
  name: 'LayerCheckbox',
  setup() {
    const submodulesVisible = ref(false);
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);
    return {
      submodulesVisible,
      getContrastActive,
    };
  },
});
export default LayerCheckbox;
